export class BusinessUnit{
    static SP = "SP";
    static CL = "CL";
    static BR = "BR";
}
export enum CoreBusinessUnit{
    Brafton = 2,
    Castleford = 7
}